module.exports = __webpack_public_path__ + "static/malu-wilz-0d62cf9942b436e338e5284e892ae575.png";